import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Form, Col, Row, Spinner } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import toast from 'react-hot-toast';
import { fetchExportAdvancePosting } from '../action/action';
import { SuccessToast, ErrorToast } from '../../../utils/Toaster';

function AdvancePostingExport() {
  const [startDate, setStartDate] = useState(
    moment(new Date()).format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format('YYYY-MM-DD')
  );
  const dispatch = useDispatch();
  const [isTypeError, setisTypeError] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState({ label: 'All', value: 'all' });

  const statusOptions = [
    {
      label: 'Status',
      options: [
        { label: 'All', value: 'all' },
        { label: 'Not Refunded', value: '0' },
        { label: 'Refunded', value: '1' }
      ],
    },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!selectedStatus) {
      setisTypeError(true);
      return;
    }
    setisTypeError(false);

    fetchExportAdvancePosting({
      params: {
        date_from: startDate,
        date_to: endDate,
        status: selectedStatus.value,
        country: localStorage.getItem('WEBSITE_COUNTRY') || "",
      },
      dispatch,
    });
  };

  const { exportAdvancePosting, isExportLoading } = useSelector(
    (state) => state.advancePosting
  );

 useEffect(() => {
    if (exportAdvancePosting?.code === 200) {
        SuccessToast(exportAdvancePosting?.message || "Export started successfully");
        if (exportAdvancePosting?.data && exportAdvancePosting?.data[0]?.report_link) {
            window.location.href = exportAdvancePosting?.data[0]?.report_link;
        }
    } else if (exportAdvancePosting?.message) {
        ErrorToast(exportAdvancePosting?.message);
    }
  }, [exportAdvancePosting]);

  const handleSelectStatus = (selectedOption) => {
    setSelectedStatus(selectedOption);
  };

  return (
      <Form onSubmit={handleSubmit}>
        <Row className="align-items-center mb-0">
          <Col md={4}>
            <Select
              value={selectedStatus}
              onChange={handleSelectStatus}
              options={statusOptions}
              classNamePrefix="select2-selection"
              placeholder="Select Status"
            />
            {isTypeError && (
              <span className="text-danger small">Please Select Status</span>
            )}
          </Col>
          <Col md={5}>
            <DateRangePicker
              placement="auto"
              placeholder="Select Date Range"
              className="w-100"
              onClean={() => {
                setStartDate(moment(new Date()).format('YYYY-MM-DD'));
                setEndDate(moment(new Date()).format('YYYY-MM-DD'));
              }}
              onChange={(selectedDates) => {
                if (selectedDates) {
                  setStartDate(moment(selectedDates[0]).format('YYYY-MM-DD'));
                  setEndDate(moment(selectedDates[1]).format('YYYY-MM-DD'));
                }
              }}
            />
          </Col>
          <Col md={3}>
            <button
              type="submit"
              className="btn btn-dark d-flex align-items-center gap-2 w-100 justify-content-center"
              disabled={isExportLoading}
            >
              {isExportLoading ? (
                <Spinner size="sm" />
              ) : (
                <i className="bx bx-download"></i>
              )}
              Export
            </button>
          </Col>
        </Row>
      </Form>
  );
}

export default AdvancePostingExport;
